var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb')], 1)]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row mb-3 align-items-center justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-auto"
  }, [_c('h4', {
    staticClass: "font-weight-bold mr-auto"
  }, [_vm._v("通知管理")])]), _c('div', {
    staticClass: "col-md-6 d-flex align-items-center"
  }, [_vm.checkPermission([_vm.consts.NOTIFICATION_MODIFY]) ? _c('router-link', {
    staticClass: "flex-shrink-0 mr-3",
    attrs: {
      "to": {
        name: 'NotificationCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("＋新增通知")])]) : _vm._e(), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "搜尋通知名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab === _vm.TABS.WAITING
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        return _vm.changeTab(_vm.TABS.WAITING);
      }
    }
  }, [_vm._v("等待發送")])]), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab === _vm.TABS.COMPLETED
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        return _vm.changeTab(_vm.TABS.COMPLETED);
      }
    }
  }, [_vm._v("已完成")])])]), _c('b-table', {
    staticClass: "mb-5",
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.computedNotifications,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(notify_type)",
      fn: function fn(data) {
        return [data.item.notify_type === 'important' ? _c('i', {
          staticClass: "fa fa-exclamation-circle"
        }) : _vm._e()];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.NOTIFICATION_MODIFY]) && data.item.canEdit ? _c('b-button', {
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'NotificationForm',
              params: {
                notification_id: data.item.id
              }
            }
          }
        }, [_vm._v("編輯")]) : _vm._e(), _vm.checkPermission([_vm.consts.NOTIFICATION_MODIFY]) && data.item.canEdit ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDeleteNotification(data.item);
            }
          }
        }, [_vm._v("刪除")]) : _vm._e(), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'NotificationView',
              params: {
                notification_id: data.item.id
              }
            }
          }
        }, [_vm._v("查看")])];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }